var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="\n<div class=\"input-group\">\n<input class=\"form-control\" ng-model=\"model[options.key]\"/>\n<span class=\"input-group-btn\" tabindex=\"-1\">\n<button class=\"btn btn-default\" type=\"button\" ng-click=\"svuota()\"><i class=\"fa fa-times\"></i></button>\n</span>\n</div>\n";
var id1="bssnumeric.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;